import React from 'react';
import ModalBase from './ModalBase';

interface PdfPageSelectorModalProps {
    isOpen: boolean;
    maxPages: number;
    onClose: (pageRange?: [number, number]) => void;
}

const PdfPageSelectorModal: React.FC<PdfPageSelectorModalProps> = ({
    isOpen,
    onClose,
    maxPages,
}) => {
    const [startPage, setStartPage] = React.useState<string>('1');
    const [endPage, setEndPage] = React.useState<string>(maxPages.toString());

    const handleStartPageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // Only allow numbers
        if (/^\d*$/.test(value)) {
            const numValue = parseInt(value || '1');
            if (numValue >= 1 && numValue <= maxPages) {
                setStartPage(value);
                // If end page is less than start page, update end page
                if (numValue > parseInt(endPage || '1')) {
                    setEndPage(value);
                }
            }
        }
    };

    const handleEndPageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // Only allow numbers
        if (/^\d*$/.test(value)) {
            const numValue = parseInt(value || '1');
            if (numValue >= parseInt(startPage) && numValue <= maxPages) {
                setEndPage(value);
            }
        }
    };

    const handleConfirm = () => {
        const start = parseInt(startPage);
        const end = parseInt(endPage);

        if (
            start >= 1 &&
            start <= maxPages &&
            end >= start &&
            end <= maxPages
        ) {
            onClose([start, end]);
        }
    };

    return isOpen ? (
        <ModalBase onClose={onClose} width="300px" hideXButton>
            <div className="pdf-page-selector-content">
                <h2>Select Page Range</h2>

                <div className="selector-row">
                    <input
                        type="number"
                        min="1"
                        max={maxPages}
                        value={startPage}
                        onChange={handleStartPageChange}
                        className="page-input"
                    />

                    <span className="range-separator">to</span>
                    <input
                        type="number"
                        min={parseInt(startPage)}
                        max={maxPages}
                        value={endPage}
                        onChange={handleEndPageChange}
                        className="page-input"
                    />

                    <p>(max. {maxPages})</p>
                </div>

                <div className="button-row">
                    <button className="btn-secondary" onClick={() => onClose()}>
                        Cancel
                    </button>
                    <button
                        className="btn-primary"
                        onClick={handleConfirm}
                        disabled={
                            !startPage ||
                            parseInt(startPage) < 1 ||
                            parseInt(startPage) > maxPages ||
                            !endPage ||
                            parseInt(endPage) < parseInt(startPage) ||
                            parseInt(endPage) > maxPages
                        }
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </ModalBase>
    ) : null;
};

export default PdfPageSelectorModal;
